import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import App from "./App";
import Login from "./Pages/Auth/Login";
import Alert from "@mui/material/Alert";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";

function AppWrapper() {
  const tokenKey = "rocco_live-access-Token-for-web";
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem(tokenKey)
  );
  const [isHiding, setIsHiding] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const msg = error?.response?.data?.message;
        if (status === 401 || msg === "Unauthorized") {
          localStorage.clear();
          setIsAuthenticated(false);
          navigate("/login");
        }
        return Promise.reject(error);
      }
    );
    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [navigate]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
    setMessage({ type: "success", text: "Login Successfully" });

    const permissions = JSON.parse(localStorage.getItem("permissions") || "[]");
    const role = localStorage.getItem("role");

    if (role === "admin" && permissions.length === 0) {
      navigate("/dashboard");
    } else if (permissions.length > 0) {
      const firstAllowed = permissions[0]?.route || "/dashboard";
      navigate(firstAllowed);
    } else {
      navigate("/dashboard");
    }
  };

  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const confirmLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem(tokenKey);
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
    localStorage.removeItem("role");
    navigate("/login");
    setLogoutDialogOpen(false);
  };

  const cancelLogout = () => {
    setLogoutDialogOpen(false);
  };

  useEffect(() => {
    if (message.text) {
      setShowAlert(true);
      setIsHiding(false);
      const timer = setTimeout(() => setIsHiding(true), 5000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  useEffect(() => {
    if (isHiding) {
      const hideTimer = setTimeout(() => {
        setShowAlert(false);
        setIsHiding(false);
      }, 500);
      return () => clearTimeout(hideTimer);
    }
  }, [isHiding]);

  return (
    <>
      <Routes>
        {isAuthenticated ? (
          <Route
            path="/*"
            element={
              <App
                onLogout={handleLogoutClick}
                message={message}
                setMessage={setMessage}
              />
            }
          />
        ) : (
          <Route
            path="/login"
            element={<Login onLoginSuccess={handleLoginSuccess} />}
          />
        )}
      </Routes>

      {showAlert && (
        <div className={`Alert-message-area ${isHiding ? "hidden" : ""}`}>
          <Alert severity={message.type}>{message.text}</Alert>
        </div>
      )}

      <Dialog open={logoutDialogOpen} onClose={cancelLogout}>
        <DialogTitle>Confirm Logout</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to log out? You will need to log in again to
            access your account.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelLogout} color="secondary">
            Cancel
          </Button>
          <Button
            onClick={confirmLogout}
            className="gradientButton"
            variant="contained"
          >
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AppWrapper;
